import PropTypes from "prop-types";
import React from "react";
import { Button, Icon } from "semantic-ui-react";

export const DraftInfoCard = ({
  title = "Drafts",
  count = 0,
  style = {},
  filter = "draft",
}) => {
  const rootStyle = {
    position: "relative",
    borderRadius: 10,
    border: "1.5px solid #2b5b7b",
    padding: "12px 14px",
    background: "#ffffff",
    textAlign: "left",
    cursor: "pointer",
    ...style,
  };

  const buttonTextContainer = {
    marginLeft: ".5rem",
  };

  const titleStyle = {
    color: "#4b4b4b",
    fontSize: 14,
    marginBottom: 8,
    fontWeight: 500,
  };

  const countStyle = {
    fontSize: 28,
    fontWeight: 700,
    color: "#111111",
    lineHeight: 1,
  };

  const arrowContainerStyle = {
    position: "absolute",
    right: 12,
    bottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const cardLink = `/me/records?q=&f=${filter}`;

  return (
    <Button
      href={cardLink}
      as="a"
      aria-label={`${title}: ${count}`}
      style={rootStyle}
    >
      <div style={buttonTextContainer}>
        <div style={titleStyle}>{title}</div>
        <div style={countStyle}>{count}</div>
        <div style={arrowContainerStyle}>
          <Icon name="external alternate" color="blue" />
        </div>
      </div>
    </Button>
  );
};

DraftInfoCard.propTypes = {
  title: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  filter: PropTypes.string,
};
